// Environment Configuration
// In a real application, these would come from environment variables
// For now, they're hardcoded but separated from the main code
const config = {
  firebase: {
    apiKey: "AIzaSyCuBq1Km_l1xqjSdKgI8YNVY5beiEPFnVU",
    authDomain: "english-reviewer-2369.firebaseapp.com",
    projectId: "english-reviewer-2369",
    storageBucket: "english-reviewer-2369.firebasestorage.app",
    messagingSenderId: "176008453308",
    appId: "1:176008453308:web:f58a3ba83d97d7f69244b9",
    measurementId: "G-Y1S4Z28PW4"
  }
};

export default config;